/**
 * General state
 */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class GeneralState {}

export { GeneralState };
